var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sac-tooltip"}},[_c('img',{staticClass:"img-size-20 clickable",attrs:{"alt":"Ruler","src":require("@shared/assets/img/general/info-dark.png")}}),_c('div',{staticClass:"tooltip-text"},[_vm._v(" "+_vm._s(_vm.tip)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }